export default __webpack_public_path__ + "static/media/serviceBanner.fe0e0347.png";